import { BrowserView, MobileView } from "react-device-detect";
import { ConfirmationVerifyOTPDesktop } from "./confirmationOTPDesktop";
import { ConfirmationVerifyOTPMobile } from "./confirmationOTPMobile";
export const ConfirmationVerifyOTP = () => {
  return (
    <>
      <BrowserView>
        <ConfirmationVerifyOTPDesktop></ConfirmationVerifyOTPDesktop>
      </BrowserView>
      <MobileView>
        <ConfirmationVerifyOTPMobile></ConfirmationVerifyOTPMobile>
      </MobileView>
    </>
  );
};
